import { createApolloClient } from 'hubspot-apollo-client';
import { DataFetchingClientProvider } from 'data-fetching-client';
import { ApolloProvider } from '@apollo/client';
import { client } from '../dataFetchingClient';
import { jsx as _jsx } from "react/jsx-runtime";
const apolloClient = createApolloClient();
export default function DFCProvider({
  children
}) {
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: client,
      children: children
    })
  });
}